import { Link } from 'react-router-dom';
import { categories, siteStats } from '@/mocks/homeData';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50" id="browse-categories">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            分类浏览
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            按分类快速找到你想看的日本影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-500/90 text-white rounded-lg">
                    <i className={`${cat.icon} text-base`}></i>
                  </div>
                  <span className="font-serif font-semibold text-white text-base md:text-lg">
                    {cat.name}
                  </span>
                </div>
                <p className="text-white/70 text-xs hidden md:block">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10">
          {siteStats.map((stat) => (
            <div key={stat.label} className="text-center p-4">
              <div className="font-serif text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}